import { Global } from "@emotion/react";

export function Fonts() {
  return (
    <Global
      styles={`
    @font-face {
      font-family: 'Helvetica Neue';
      font-style: normal;
      font-weight: 900;
      font-display: swap;
      src: url(./HelveticaNeue/HelveticaNeueLTStd-Bd.woff2) format('woff2');
      unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
    }

    @font-face {
      font-family: 'Futura Book';
      font-style: normal;
      font-display: swap;
      src: url(https://punch-studios.com/wp-content/themes/uncode-child/fonts/Futura-Book.woff2) format('woff2');
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }

    @font-face {
      font-family: 'Futura ExtraBold';
      font-style: normal;
      font-display: swap;
      src: url(./Futura/Futura-ExtraBold.woff2) format('woff2');
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }
    `}
    />
  );
}
